module.exports = __webpack_public_path__ + "img/8.c28ac2dc.jpg";